import { createContext } from 'react';
import type { CookiePreferencesState } from '@/features/cookie/types';

export interface CookieContextType {
  preferences: CookiePreferencesState | null;
  hasConsent: boolean;
  isPopoverOpen: boolean;
  acceptAll: () => void;
  acceptPreferences: (preferences: CookiePreferencesState) => void;
  updatePreferences: (preferences: Partial<CookiePreferencesState>) => void;
  clearConsent: () => void;
  showPopover: () => void;
  hidePopover: () => void;
  togglePopover: () => void;
  isCookiePreferencesOpen: boolean;
  setIsCookiePreferencesOpen: (open: boolean) => void;
}

export const CookieContext = createContext<CookieContextType | undefined>(
  undefined
);
